"use strict";

angular.module('rmCampaign')

.directive('campaignBroadcastBlock', ['$urlRouter', 'moment', function ($urlRouter, moment ) {

	return {
		restrict: 'E',
		scope: {
			broadcast: '=',
			block: '=',
			ngModel: '=',
			ngRemove: '=',
			items: '=',
			itemCount: '='
		},
		template: `
			<div class="giveaway" layout="column" layout-align="end center" title="{{broadcast.title}}" style="border: 1px solid black">
	            <span class="giveaway__title">{{broadcast.title}}</span>
	            <div class="giveaway__chip" ng-show="count">{{count}}</div>
				<div class="giveaway__addsubstract" layout="row" layout-align="space-around center">
	                <md-button subtract>-</md-button>
	                <span class="giveaway__count">{{count}}</span>
	                <md-button add>+</md-button>
	            </div>
            </div>`,
		replace: true,
		require: 'ngModel',
		link: function ( scope, element, attrs ) {

			scope.block._date = moment(scope.block.start).format('YYYY-MM-DD');

			var epgTotalHeight = 1200; //pixels of epg div
			var totalMinutesDay = 1440; //total minutes on a day

			var block = scope.block.id,
				// @todo(Saar) We can better watch this variable for async
				items = scope.items.filter((item) => {
					return item.block_id == block;
				});

			if( !block ) {
				throw 'Block id not found';
			}

			scope.count = items.length;

			if( !Array.isArray(scope.ngModel) ) {
				scope.ngModel = [];
			}

			if( !Array.isArray(scope.ngRemove) ) {
				scope.ngRemove = [];
			}

			function calculateTop ( start ) {

				var blockStartTime = moment(start);
				var dayStartTime = moment(start);
				dayStartTime.set('minutes', 0);
				dayStartTime.set('hours', 0);
				dayStartTime.set('seconds', 0);

				var minutesFromDayStart = ( blockStartTime.format('X') - dayStartTime.format('X') ) / 60;

				return ( minutesFromDayStart * epgTotalHeight) / totalMinutesDay;
			}

			function calculateHeight ( start, stop ) {

				var blockMinutes = (moment(stop).format('X') - moment(start).format('X')) / 60; //minutes of program

				return (blockMinutes * epgTotalHeight) / totalMinutesDay;
			}

			var top = calculateTop(scope.block.start),
				height = calculateHeight(scope.block.start, scope.block.stop);

			element.css({
				top: (top+8)+'px', //add 8px offset
				height: height+'px',
			});

			element.on('click', (event) => {

				let add = jQuery(event.target).closest('[add]')[0],
					substract = jQuery(event.target).closest('[subtract]')[0];

				if( add ) {
					addItem();
				}

				if( substract ) {
					subtractItem();
				}
			});

			function addItem () {
				scope.count += 1;
				scope.itemCount += 1;

				scope.ngModel.push(block);
			}

			function subtractItem () {

				if( scope.count === 0 ) {
					return;
				}

				let index = scope.ngModel.indexOf(block);

				if( index !== -1 ) {
					// Remove from memory
					scope.ngModel.splice(index, 1);
				} else {
					// @todo(Saar) add to removed item ids
					let item = items.pop();
					scope.ngRemove.push(item.id);
				}

				scope.count -= 1;
				scope.itemCount -= 1;
			}
		}
	};
} ] );
